// TODO: restore isDebug() guard before deploying
// import { isDebug } from './debug';
import { log } from './logger';

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(registration => {
        // Check for updates every 60 minutes. update() rejects on flaky
        // networks and mid-deploy — expected, never an app error (KL-1N).
        // Log to the log-service (not Sentry) so an SW-serving regression
        // still leaves an ops trail.
        setInterval(() => {
          registration
            .update()
            .catch(err => log(`ServiceWorker update failed: ${err}`));
        }, 1000 * 60 * 60);
      })
      .catch(() => {});
  });
}
